import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'pl', label: 'Polski' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find((l) => l.code === (i18n.language?.split('-')[0] || 'en')) || languages[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem('usfans-lang', code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-background-300/70 bg-white/70 px-3 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
        aria-label="Change language"
      >
        <span className="w-4 h-4 flex items-center justify-center text-primary-600">
          <i className="ri-global-line" />
        </span>
        <span>{current.label}</span>
        <span className="w-3 h-3 flex items-center justify-center text-foreground-500">
          <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-background-200 bg-white py-1">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => changeLanguage(lang.code)}
              className={`flex w-full items-center justify-between px-4 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                lang.code === current.code
                  ? 'bg-primary-50 font-semibold text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {lang.label}
              {lang.code === current.code && (
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-check-line" />
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}